import moment from 'moment';

import { AccountConnectorServiceEnum } from '~/generated/graphql';

import MetricWithPastValueComparison from '../MetricWithPastValueComparison';
import { useQueryEnrichmentMetric } from '../useQueryEnrichmentMetric';

type EnrichmentMetricRateProps = {
  className?: string;
  denominatorMetricName: string;
  displayName: string;
  externalType: AccountConnectorServiceEnum;
  loadingSkeletonWidth?: string;
  numeratorMetricName: string;
  queryStartDate: moment.Moment;
};

function EnrichmentMetricRate({
  className,
  displayName,
  loadingSkeletonWidth,
  numeratorMetricName,
  denominatorMetricName,
  externalType,
  queryStartDate,
}: EnrichmentMetricRateProps) {
  const numeratorRespData = useQueryEnrichmentMetric({
    queryStartDate: queryStartDate,
    queryEndDate: moment(),
    metricName: numeratorMetricName,
    externalType: externalType,
  });
  const denominatorRespData = useQueryEnrichmentMetric({
    queryStartDate: queryStartDate,
    queryEndDate: moment(),
    metricName: denominatorMetricName,
    externalType: externalType,
  });

  const currentRangeLoading =
    numeratorRespData.currentRangeLoading ||
    denominatorRespData.currentRangeLoading;
  const pastRangeLoading =
    numeratorRespData.pastRangeLoading || denominatorRespData.pastRangeLoading;
  const currentRangeNumerator =
    numeratorRespData?.currentRangeData?.uniques || 0;
  const currentRangeDenominator =
    denominatorRespData?.currentRangeData?.uniques || 0;
  const pastRangeNumerator = numeratorRespData?.pastRangeData?.uniques || 0;
  const pastRangeDenominator = denominatorRespData?.pastRangeData?.uniques || 0;
  const currentRangeValue = Math.round(
    (currentRangeNumerator / currentRangeDenominator) * 100,
  );
  const pastRangeValue = Math.round(
    (pastRangeNumerator / pastRangeDenominator) * 100,
  );

  return (
    <MetricWithPastValueComparison
      className={className}
      currentRangeLoading={currentRangeLoading}
      currentRangeValue={
        !currentRangeValue || currentRangeValue == Infinity
          ? 0
          : currentRangeValue
      }
      displayName={displayName}
      loadingSkeletonWidth={loadingSkeletonWidth}
      pastRangeLoading={pastRangeLoading}
      pastRangeValue={
        !pastRangeValue || pastRangeValue == Infinity ? 0 : pastRangeValue
      }
      suffix="%"
    />
  );
}

export default EnrichmentMetricRate;
